<template>
  <div class="flex flex-col gap-2 w-full h-full">
    <div class="flex flex-col gap-2">
      <span class="font-semibold mb-1">הערה על הביקור</span>
      <Textarea
        id="description"
        v-model="note"
        autofocus
        :autoResize="false"
        class="w-full mb-2"
        cols="30"
        rows="2"/>
    </div>

    <div class="flex flex-col gap-3">
      <span class="font-semibold">הוספת תמונות</span>
      <multiple-images-upload :images="images" @images-change="changeMedia"/>
    </div>

    <drawer-footer
      :approveLoading="loading"
      @approve-click="clickCTA"
      @cancel-click="$emit('close')"
    />
  </div>
</template>

<script setup lang="ts">
import {ref} from 'vue'
import {useToast} from 'vue-toastification'
import {CustomersApi} from '@app/api/admin/customers-api'
import type {ICustomerTimeline, ITreatmentGoal} from '@torim-app/types'
import {BusinessModuleType} from "@torim-app/types";
import MultipleImagesUpload from "@app/components/admin/components/MultipleImagesUpload.vue";
import {useAdminStore} from "@app/stores";
import { trackEvent } from '@app/composables/posthog';

// Define props using generic type
interface Props {
  appointment?: ICustomerTimeline;
}

// Define props and emit
const props = defineProps<Props>()
const emit = defineEmits(['close'])

const toast = useToast()
const adminStore = useAdminStore();

const note = ref(props.appointment?.adminNote)
const images = ref<Array<string>>(props.appointment?.images ?? [])
const loading = ref(false)


// Methods
const changeMedia = (updatedImages: string[]) => {
  images.value.splice(0);
  images.value.push(...updatedImages);
  console.log('updatedImages', updatedImages)
}

const clickCTA = (): void => {
  trackEvent('summary_note_added');
  const appointmentId = props.appointment?.appointmentId
  if (appointmentId && (note.value !== '' || images.value.length > 0)) {
    loading.value = true
    CustomersApi.addNoteToAppointment(appointmentId, {
      note: note.value,
      images: images.value,
    })
      .then(_ => toast.success("הערה נוספה לתור"))
      .catch(_ => toast.error("לא הצלחנו להוסיף הערה לתור"))
      .finally(() => {
        loading.value = false
        emit('close', true)
      })
  }
}
</script>
